// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"3382bda0","342":"b49fee17","639":"5e3ce845","704":"3fa2da04","864":"093cda61"}[chunkId] + ".chunk.js";
};